// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"689":"1e4135a7","997":"b9da1671"}[chunkId] + ".chunk.css";
};